import React from "react";
import {useNavigate} from "react-router-dom";
import ApplicationCard from "../common/ApplicationCard";

const SelfRegistrationCard: React.FC = () => {
    const navigate = useNavigate();

    const handleSelfRegistrationClick = () => {
        navigate('/self-registration', { state: { from: 'self-registration' } });
    };

    return (
        <div onClick={handleSelfRegistrationClick} style={{ cursor: 'pointer' }}>
            <ApplicationCard
                title="Self Registration"
                description="Register for access to applications"
                url={null}
            />
        </div>
    );
};
export default SelfRegistrationCard;